module.exports = __webpack_public_path__ + "static/media/home_rocket_guppy.3ebeb5c9.jpeg";